// src/firebase/itemsAndInventory/deleteItem.ts
import { ref, update } from "firebase/database";
import { db } from "../firebaseConfig";

export const deleteItem = async (itemId: string) => {
	try {
		const itemRef = ref(db, `items/${itemId}`);
		await update(itemRef, { isDeleted: true });
	} catch (error) {
		console.error("Error soft deleting item:", error);
		throw error;
	}
};
